import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { IExportListComponent, IRefExportListComponent } from "./interface";

export const scorplanSpaceString = "@5C0R3@PL4N@";
const classOfUl = "class-to-export-list-component-of-score";

const exportColumnData = (columnElement: Element): string => {
	const lastLevelColumnsContent = [...columnElement.querySelectorAll("*")].filter((x) => x.children.length === 0);
	let line = "";

	lastLevelColumnsContent.forEach((content) => {
		if(content.textContent !== null)
			line += `${content.textContent.trimStart().replace(scorplanSpaceString, "   ")} `;
	});

	line += ";";

	return line;
};

const executeExportData = (ul: HTMLUListElement, dataToExport: string[], classToBreakLineInsideSameColumn?: string) => {
	const lis = ul.childNodes;
	lis.forEach((li) => {
		const liElement = li as HTMLLIElement;

		if(liElement.classList.contains("is-children")){
			const ulOfLi = liElement.querySelector(`ul.${classOfUl}`);
			if(ulOfLi && ulOfLi !== null){
				executeExportData(ulOfLi as HTMLUListElement, dataToExport, classToBreakLineInsideSameColumn);
				return;
			}
		}
		
		let line = "";

		const columns = liElement.childNodes;

		columns.forEach((column) => {
			const columnElement = column as Element;

			if(classToBreakLineInsideSameColumn && columnElement.querySelector(`.${classToBreakLineInsideSameColumn}`)){
				const customColumns = columnElement.querySelectorAll(`.${classToBreakLineInsideSameColumn}`);

				customColumns.forEach((customColumn) => {
					const customColumnElement = customColumn as Element;
					line += exportColumnData(customColumnElement);
				});
				return;
			}

			line += exportColumnData(columnElement);
		});

		dataToExport.push(line);	
	});
};

const ExportListContainer: React.ForwardRefRenderFunction<IRefExportListComponent, IExportListComponent> = ({
	children,
	classToBreakLineInsideSameColumn,
	style
}, ref) => {
	const localRef = useRef<IRefExportListComponent>(null);
	const internalRef = ref ?? localRef;
	const HTMLElementRef = useRef<HTMLDivElement>(null);
		
	const executeExport = () => {
		const dataToExport: string[] = [];

		if(HTMLElementRef.current?.querySelectorAll("ul").length === 0)
			return dataToExport;

		const ul = HTMLElementRef.current?.firstChild?.firstChild;

		if(!ul || ul === null)
			return dataToExport;

		executeExportData(ul as HTMLUListElement, dataToExport, classToBreakLineInsideSameColumn);	

		return dataToExport.filter((x) => x.trim().length > 0);
	};

	useImperativeHandle(internalRef, () => ({
		executeExport
	}));
    
	return <div ref={HTMLElementRef} style={style}>
		{children}
	</div>;
};

export default forwardRef(ExportListContainer);
